import type { ReactNode } from 'react';
import {
  PageRoot,
  Frame,
  Glyph,
  Title,
  Body,
  Actions,
  type StateTone,
} from './FullPageState.styled';

interface FullPageStateProps {
  tone?: StateTone;
  glyph: ReactNode;
  glyphSize?: 'md' | 'lg';
  title: string;
  body?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
  dark?: boolean;
  warn?: boolean;
}

export function FullPageState({
  tone = 'neutral',
  glyph,
  glyphSize,
  title,
  body,
  actions,
  meta,
  dark,
  warn,
}: FullPageStateProps) {
  return (
    <PageRoot $dark={dark} $warn={warn}>
      <Frame $dark={dark} $warn={warn} data-surface={dark ? 'navy' : undefined}>
        <Glyph $tone={tone} $size={glyphSize} aria-hidden>{glyph}</Glyph>
        <Title $dark={dark}>{title}</Title>
        {body ? <Body $dark={dark}>{body}</Body> : null}
        {actions ? <Actions>{actions}</Actions> : null}
        {meta}
      </Frame>
    </PageRoot>
  );
}
